module.exports = addComment

const dateToIdFriendlyTimestamp = require('./tools/date-to-id-friendly-timestamp')
const { SHIPMENT_VERSIONS } = require('./constants')

const toCommentId = (snapshotId, createdAt) => {
  const timestamp = dateToIdFriendlyTimestamp(createdAt)
  return `${snapshotId}:comment:${timestamp}`
}

async function addComment (state, snapshotId, comment, signature, name, orderId, phoneNumber, adjustmentReasons) {
  if (!(comment || signature || name)) {
    return
  }

  const now = new Date()
  const createdAt = now.toISOString()
  const createdBy = state.user.name
  const _id = toCommentId(snapshotId, now)

  const doc = {
    _id,
    type: 'snapshot-comment',
    version: SHIPMENT_VERSIONS.VERSION_2,
    createdAt,
    createdBy
  }

  if (comment) {
    doc.comment = comment
  }

  if (signature) {
    doc.signature = signature
  }

  if (name) {
    doc.name = name
  }

  if (orderId) {
    doc.orderId = orderId
  }

  if (phoneNumber) {
    doc.phoneNumber = phoneNumber
  }

  if (adjustmentReasons) {
    doc.adjustmentReasons = adjustmentReasons
  }

  await state.dal.shipment.write(state, doc)

  const response = {
    _id,
    snapshotId,
    createdAt,
    createdBy,
    comment,
    signature,
    name,
    phoneNumber,
    adjustmentReasons
  }
  if (orderId) {
    response.orderId = orderId
  }
  return response
}
